import { CurrentAccountPersonalCertificateDecryptPrivateKeyCommand } from '@dreryk/egabinet-personal-certificate-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { AuthenticationCommonFault, useAuthenticationCommonFaultHandlerMap } from '@dreryk/egabinet-security-frontend';
import { PromiseVoidFunction } from '@dreryk/react-common';

import { CertificateFault, useCertificateFaultHandlerMap } from '../certificate/useCertificateFaultHandlerMap';

import { AccountAuthorizationFormBean } from './form/AccountAuthorizationForm.types';

type AuthenticateActionRenderProps = {
   authenticate: (formData: AccountAuthorizationFormBean) => Promise<void>;
};

type AuthenticateActionProps = {
   children: (renderProps: AuthenticateActionRenderProps) => JSX.Element;
   onSuccess: PromiseVoidFunction;
   onLoginFault: VoidFunction;
};

export const AuthenticateAction = (props: AuthenticateActionProps): JSX.Element => {
   const { executeAsync: authenticate } = useCqrsCommand<
      void,
      AccountAuthorizationFormBean,
      AuthenticationCommonFault | CertificateFault
   >(
      (parameters) => {
         const command = new CurrentAccountPersonalCertificateDecryptPrivateKeyCommand();
         command.accountPassword = parameters.accountPassword!;
         return command;
      },
      {
         onSuccess: props.onSuccess,
         onFault: {
            ...useAuthenticationCommonFaultHandlerMap({
               onLoginFault: props.onLoginFault,
            }),
            ...useCertificateFaultHandlerMap(),
         },
      }
   );

   return props.children({
      authenticate: authenticate,
   });
};
